import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Ensure tab key works properly
    this.element.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        // Allow default tab behavior
        return true
      }
    })
  }
} 